import React from 'react'
import Helper from '../functions/Helper.js'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

export default class SizeScale extends React.Component{

  render(){
    return(
      <div style={{flex:1,cursor:"pointer"}}>
  			<div style={{display: 'flex'}}>
  				<div style={{flex: '1 1 0%', textAlign: 'left', fontSize: 12}}>{this.props.type==="width" ? "narrow" :"small"}</div>
  				<div style={{flex: '1 1 0%', textAlign: 'right', fontSize: 12}}>{this.props.type==="width" ? "wide" :"large"}</div>
  			</div>
  			<div style={{display: 'flex', position: 'relative'}}>
  				<div style={{flex: '1 1 0%', height: 15, borderStyle: 'solid', backgroundColor: '#e5e5e5', borderColor: '#999999', borderWidth: 1}}></div>
  				<div style={{flex: '1 1 0%', height: 15, borderStyle: 'solid', backgroundColor: '#e5e5e5', borderColor: '#999999', borderWidth: 1}}></div>
  				<div style={{flex: '1 1 0%', height: 15, borderStyle: 'solid', backgroundColor: '#e5e5e5', borderColor: '#999999', borderWidth: 1}}></div>
  				<div style={{flex: '1 1 0%', height: 15, borderStyle: 'solid', backgroundColor: '#e5e5e5', borderColor: '#999999', borderWidth: 1}}></div>
  				<div style={{flex: '1 1 0%', height: 15, borderStyle: 'solid', backgroundColor: '#e5e5e5', borderColor: '#999999', borderWidth: 1}}></div>
          <OverlayTrigger placement="bottom" overlay={
            <Tooltip  style={{fontSize:15}} id="tooltip"> The {this.props.shoe_name} {this.props.type=== "width" ? "is" :""} {Helper.getSizeDescription(this.props.percent,this.props.type,"normal")
            }
            </Tooltip>
          }>
            <div className="size_scale_indicator" style={{position: 'absolute', height: 15,border:"1px solid border: 1px solid var(--primary-color-800)",backgroundColor: 'var(--primary-color-600)', width: '20%', opacity: 0.9, textAlign: 'center', color: 'white', left:this.props.percent*0.8 + "%"}}> </div>
          </OverlayTrigger>
    		 </div>
  		</div>
    );
  }
}
